/**
 * notification-service base URL (Portal FE migration).
 * @see Portal-FE-Migration.html — notification / message blast
 */
export function getNotificationApiBase() {
    const config = window.__RUNTIME_CONFIG__ || {};
    if (config.REACT_APP_NOTIFICATION_API_URL) {
        const url = config.REACT_APP_NOTIFICATION_API_URL;
        return url.endsWith('/') ? url : `${url}/`;
    }
    const root = window.ApiURL || '';
    return root.endsWith('/') ? `${root}notification/` : `${root}/notification/`;
}
